import { PocButton } from 'commons/components/components-wrapper/poc-button.component';
import { PocIcon } from 'commons/components/components-wrapper/poc-icon.component';
import { useDeviceTypes } from 'core/contexts/device-types/hooks/use-device-types.hook';
import { useTranslation } from 'core/i18n/i18n';
import { PredefinedCommentDeviceTypeEntry } from 'modules/settings/pods/settings-devices/settings-devices-predefined-comments/settings-devices-predefined-comments-form/settings-devices-predefined-comments-form.model';
import { PredefinedCommentDeviceTypeCard } from '../predefined-comment-device-type-card/predefined-comment-device-type-card.component';
import { useLocations } from 'core/custom-hooks/use-locations.hook';

export interface PredefinedCommentDeviceTypeListProps {
    entries: PredefinedCommentDeviceTypeEntry[];
    onAddEntry: () => void;
    onRemoveEntry: (entryId: string) => void;
    onChangeEntry: <K extends keyof PredefinedCommentDeviceTypeEntry>(
        entryId: string,
        field: K,
        value: PredefinedCommentDeviceTypeEntry[K]
    ) => void;
}

export const PredefinedCommentDeviceTypeList: React.FC<PredefinedCommentDeviceTypeListProps> = ({
    entries,
    onAddEntry,
    onRemoveEntry,
    onChangeEntry,
}) => {
    const { t } = useTranslation();
    const { deviceTypes } = useDeviceTypes();
    const { locations } = useLocations();

    const selectedDeviceTypeIds = new Set(entries.map((entry) => entry.deviceTypeId).filter(Boolean));

    const getAvailableOptions = (currentDeviceTypeId?: string) =>
        deviceTypes.filter(
            (dt) => (!!dt.id && dt.id === currentDeviceTypeId) || (dt.id && !selectedDeviceTypeIds.has(dt.id))
        );

    return (
        <>
            {entries.map((entry) => (
                <PredefinedCommentDeviceTypeCard
                    locations={locations}
                    key={entry.id}
                    entry={entry}
                    deviceTypeOptions={getAvailableOptions(entry.deviceTypeId)}
                    onChangeEntry={onChangeEntry}
                    onRemove={onRemoveEntry}
                    canRemove={entries.length > 1}
                />
            ))}
            <PocButton variant="secondary" onClick={onAddEntry}>
                <PocIcon slot="prefix" name="circle_add" />
                {t('settings.devices.predefined-comments.form.device-type.add')}
            </PocButton>
        </>
    );
};
